import { useState } from "react";
import { notificacionError } from "@/components/Alerts";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "@/components/modals/BaseModal";
import { TablaSubpuestos } from "./TablaSubpuestos";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { useQuery, useQueryClient } from "@tanstack/react-query";

interface ModalPuestoProps extends BaseModalProps {
	readonly idPuesto: string;
}
export function ModalPuesto(props: ModalPuestoProps) {
	const [creating, setCreating] = useState(false);

	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title">Subpuestos {props.idPuesto}</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body" style={{ minWidth: "600px" }}>
				{!creating && (
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: "2%", gap: "2em" }}>
						<div />
						<button type="button" className="btnPrimary" onClick={() => { setCreating(true); }}>
							Nuevo subpuesto
						</button>
					</div>
				)}

				{creating ? (
					<EdicionSubpuesto
						idPuesto={props.idPuesto}
						setCreating={setCreating}
					/>
				) : null}

				<div className="table-responsive" style={{ marginBottom: "2%" }}>
					<TablaSubpuestos idPuesto={props.idPuesto} />
				</div>
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>
					Cerrar
				</button>
			</div>
		</BaseModal>
	);
}

interface EditarSubpuestoProps {
	readonly idPuesto: string;
	readonly setCreating: (creating: boolean) => void;
}
function EdicionSubpuesto(props: EditarSubpuestoProps) {
	const queryClient = useQueryClient();
	const [nameSubpuesto, setNameSubpuesto] = useState("");
	const [codeSubpuesto, setCodeSubpuesto] = useState("");

	const guardarSubpuesto = () => {
		void sendAjaxRequest<RespuestaSubpuesto>("POST", "/api/v1/editarSubpuesto", {
			tipo: "anadir",
			idPuestoPadre: props.idPuesto,
			codigo: codeSubpuesto,
			nombre: nameSubpuesto,
		}).then((response) => {
			if (response.tipo != "success") {
				notificacionError(response.message);
				return;
			}

			props.setCreating(false);
			return queryClient.invalidateQueries({ queryKey: ["getSubpuestos", props.idPuesto] });
		});
	};

	return (
		<div style={{ display: "grid", gridTemplateColumns: "1fr 2fr 1fr 3fr", gap: "1em", alignItems: "baseline", padding: "10px 2em", paddingTop: "0", border: "1px solid #ccc", borderRadius: "8px", marginBottom: "2%" }}>
			<h1 style={{ gridColumn: "span 4" }}>Creando Subpuesto</h1>

			<label className="labelsForm" style={{ margin: "0" }}>
				Id
			</label>
			<input
				type="text"
				className="inputsForm"
				value={codeSubpuesto}
				onChange={(event) => { setCodeSubpuesto(event.target.value); }}
			/>

			<label className="labelsForm" style={{ margin: "0" }}>
				Nombre
			</label>

			<input
				type="text"
				className="inputsForm"
				value={nameSubpuesto}
				onChange={(event) => { setNameSubpuesto(event.target.value); }}
			/>

			<button style={{ gridColumn: "span 2" }} type="button" className="btnSecondary" onClick={() => { props.setCreating(false); }}>
				Cancelar
			</button>
			<button style={{ gridColumn: "span 2" }} type="button" className="btnPrimary" onClick={guardarSubpuesto}>
				Guardar
			</button>
		</div>
	);
}

export function useSubPuestos(idPuesto: string) {
	return useQuery({
		queryKey: ["getSubpuestos", idPuesto],
		queryFn: () => {
			return sendAjaxRequest<Subpuesto[]>("GET", "/api/v1/getSubpuestos", {
				"idPuesto": idPuesto
			});
		},
	});
}
export interface Subpuesto {
	id: number;
	codigo_padre: string;
	codigo_subpuesto: string;
	nombre: string;
}

type RespuestaSubpuesto = {
	tipo: "success";
	subpuesto: Subpuesto;
} | {
	tipo: "error";
	message: string;
};
